import { KlevuTypeOfRecord } from "../../index.js";
import { search } from "../search/search.js";
/**
 * Search helper function that sets correct settings
 *
 * @category RecommendationQuery
 * @param term category to find
 * @param options
 * @returns
 */
export function searchCategory(term, options) {
    return search(term, Object.assign({ typeOfRecords: [KlevuTypeOfRecord.Category], groupBy: "name" }, options));
}
